// クーポンの割引タイプ
export const COUPON_DISCOUNT_TYPES = {
  FIXED: '固定額',
  RATE: 'パーセント割',
} as const;
// クーポンのステータス
export const COUPON_STATUS_TYPES = {
  active: '期間中',
  disabled: '無効',
  expired: '終了',
  not_started: '開始前',
} as const;

// クーポンインターフェース
export interface Coupon {
  id: number;
  name: string | null;
  code: string;
  discount_type: keyof typeof COUPON_DISCOUNT_TYPES;
  discount_value: number;
  discount_display: string;
  start_date: string;
  end_date: string | null;
  usages_count: number;
  usage_limit: number | null;
  usage_status: string;
  disabled: boolean;
  is_active: boolean;
  can_delete: boolean;
  remarks: string | null;
  created_at: string;
  updated_at: string;
}

// クーポン一覧のレスポンス型
export interface CouponListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Coupon[];
}

// クーポン検索パラメータ
export interface CouponSearchParams {
  page?: number;
  page_size?: number;
  search?: string;
  status?: keyof typeof COUPON_STATUS_TYPES;
  discount_type?: keyof typeof COUPON_DISCOUNT_TYPES;
  disabled?: boolean;
  valid_on?: string;
  ordering?: string;
}

export interface CouponCreateRequest {
  code: string;
  name: string;
  discount_type: keyof typeof COUPON_DISCOUNT_TYPES;
  discount_value: number;
  start_date: string;
  end_date?: string | null;
  usage_limit?: number | null;
  remarks?: string;
}

export interface CouponCreateResponse {
  id: number;
  message: string;
}

export interface CouponUpdateRequest {
  code?: string;  // 開始前のクーポンのみ変更可能
  name: string;
  discount_type: keyof typeof COUPON_DISCOUNT_TYPES;
  discount_value: number;
  start_date: string;
  end_date?: string | null;
  usage_limit?: number | null;
  remarks?: string;
  disabled?: boolean;
}

export interface CouponUpdateResponse {
  id: number;
  message: string;
}

export interface PatientBasic {
  id: number;
  name: string;
  nickname: string;
}

export interface NurseBasic {
  id: number;
  name: string;
  nickname: string;
}

export interface TalkSessionBasic {
  id: number;
  start_at: string | null;
  end_at: string | null;
  parent_id: number;  // 看護師ID
  child_id: number;   // 患者ID
  nurse: NurseBasic | null;
}

export interface CouponUsage {
  id: number;
  patient: PatientBasic;
  talk_session: TalkSessionBasic | null;
  discount_amount: number;
  talk_plan_price: number;
  used_at: string;
  remarks: string | null;
  created_at: string;
  updated_at: string;
}
